import React, { useRef, useState, useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import { InlineIcon } from '@iconify/react';
import fileDownloadFill from '@iconify/icons-ri/file-download-fill';

import useResponsive from '../hooks/useResponsive'
import CareerAccordion from './careeraccordion'
import CareerBox from './careerbox'
import JobSearch from './jobsearch'

gsap.registerPlugin(ScrollTrigger);

export default () => {

  const { isMobileText, isMobileAccordion } = useResponsive()
  
  // Hard data, should be elsewhere probably like on strapi or smthing
  const data = [
    {
      key: `aodocs`,
      title: `Aodocs`,
      desc: `Développement de la nouvelle interface du produit AODocs : plateforme de gestion business intégrée à Google Drive (partenaire Google).`,
      stack: [
        [
          `typescript`,
          `angular`,
        ],
        [
          `scss`,
          `bem`,
          `material`,
        ],
        [
          `git`,
          `npm`,
          `webpack`,
        ],
      ],
      jobTitle: 'Front-End',
    },
    {
      key: `freelance`,
      title: `Freelance`,
      desc: `Développement et mise en production de sites sous Wordpress. Thèmes et plugins sur mesure.`,
      stack: [
        [
          `wordpress`,
          `symphony`,
        ],
        [
          `php`,
          `javascript`,
          `ajax`,
        ],
      ],
      jobTitle: 'Full-Stack',
    },
    {
      key: `bronx`,
      title: `Bronx Agence`,
      desc: `Développement de sites vitrines et événementiels dans le domaine du culturel et de la mode (ARTE, TF1/NT1, L'Oréal, Grand Palais de Paris, etc.)`,
      stack: [
        [
          `wordpress`,
          `jquery`,
        ],
        [
          `photoshop`,
          `flash`,
        ],
      ],
      jobTitle: 'Full-Stack',
    },
    {
      key: `epitech`,
      title: `Epitech Paris`,
      desc: `EPITECH Paris met l'accent sur l'autonomie.<br/> Les élèves apprennent ainsi à s'affranchir des technologies successives et sont en capacité de s'adapter aux nouveautés intuitivement.`,
      stack: [
        [
          `c`,
          `c++`,
          `java`,
        ],
        [
          `php`,
          `javascript`,
          `sql`,
        ],
      ],
      jobTitle: 'Master',
    },
    {
      key: `biologie`,
      title: `[Biologie]`,
      desc: `Licence complète + deux stages&nbsp;:<br>
      - Laboratoire de bioinformatique de l'université<br>
      - Centre de Recherche en Cancérologie et Immunologie de Nantes.`,
      jobTitle: 'Licence',
    },
  ]

  const [currentPlace, setCurrentPlace] = useState(data[0]);
  const revRef = useRef(null)

  useEffect(() => {
    gsap
      .timeline({ repeat: -1, repeatDelay: 5, })
      .set('.about__bg',
        { className: 'about__bg glitching' })
      .set('.about__bg',
        { className: 'about__bg' }, 2.5)

    gsap
      .timeline({ repeat: -1, repeatDelay: 5, })
      .set('.about__red-bg',
        { className: 'about__red-bg glitching' })
      .set('.about__red-bg',
        { className: 'about__red-bg' }, 2.5)

    // +.2 second delay
    gsap
      .timeline({ repeat: -1, repeatDelay: 5, })
      .set('.about__blue-bg',
        { className: 'about__blue-bg glitching' }, .2)
      .set('.about__blue-bg',
        { className: 'about__blue-bg' }, 2.7)
  }, [])

  useEffect(() => {
    // ScrollTrigger for about
    gsap
      .timeline({
        scrollTrigger: {
          id: `about`,
          trigger: '.about',
          start: 'top bottom-=200',
          toggleActions: 'play none none none',
          markers: false,
        },
      })
      .fromTo('.about__photo, .about__title, .about__text > p', {
        autoAlpha: 0,
        y: 100,
      }, {
        autoAlpha: 1,
        y: 0,
        stagger: .2,
      })

    // ScrollTrigger for career
    gsap
      .timeline({
        scrollTrigger: {
          id: `career`,
          trigger: '.career',
          start: 'top bottom-=200',
          toggleActions: 'play none none none',
          markers: false,
        },
      })
      .fromTo('.career__title, .career__box, .jobSearch, .jobSearch__title, .jobSearch__text, .jobSearch__field', {
        autoAlpha: 0,
        y: 100,
      }, {
        autoAlpha: 1,
        y: 0,
        stagger: .2,
      })
      .fromTo('.about__fox', {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
      })

  }, [revRef])


  return (
    <div ref={revRef} className="about">
      <div className="about__text">
        <h2 className="about__title title is-2">A propos</h2>
        <p className={"content" + (isMobileText ? " is-medium" : "")}>
          J'ai étudié l'informatique à EPITECH Paris avant de devenir développeur web à <a className="about__textLink glitch-link" target="_blank" rel="noreferrer" href="https://www.bronx.fr/" data-text="Bronx Agence Paris">Bronx Agence Paris</a>, produisant des sites vitrines et événementiels pour ARTE, TF1, L'Oréal, Le Grand Palais de Paris, etc. Après quelques années de freelance, j'ai ensuite opéré en tant que Front-End sur l'application <a className="about__textLink glitch-link" target="_blank" rel="noreferrer" href="https://www.aodocs.com/" data-text="AODocs">AODocs</a> en contact avec l'équipe de Google Drive.
        </p>
        <p className={"content" + (isMobileText ? " is-medium" : "")}>
          J'aime concevoir des interfaces propres et intuitives, avec un soin particulier apporté aux animations. Passionné de jeux vidéo — au point d'avoir écrit dans des magazines et sites spécialisés ! —, je considère le ludisme comme essentiel dans tout projet.
        </p>
      </div>
      <div className="about__photoWrapper">
        <figure className="about__photo image is-square">
          <div className="about__red-bg has-ratio"></div>
          <div className="about__blue-bg has-ratio"></div>
          <img className="about__bg" src="https://res.cloudinary.com/dzxowa2ja/image/upload/v1600251124/photo_k0f0be.jpg" alt="Léo's face" />
        </figure>
      </div>
      <div className="about__career career">
        <h2 className="career__title title is-3">Parcours <a data-tooltip="Télécharger mon CV complet" aria-label="Télécharger mon CV complet" href="https://drive.google.com/file/d/1azEh8z83PK1mWS4a3QWUZMJgm-u2WRJX/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="about__resumeLink"><InlineIcon className="about__resumeIcon" height={32} icon={fileDownloadFill} /></a></h2>
        { isMobileAccordion &&
          <CareerAccordion
            data={data} currentPlace={currentPlace} setCurrentPlace={setCurrentPlace} /> }
        { !isMobileAccordion &&
          <CareerBox
            data={data} currentPlace={currentPlace} setCurrentPlace={setCurrentPlace} /> }
      </div>
      <JobSearch/>
      <img className="about__fox" src="https://res.cloudinary.com/dzxowa2ja/image/upload/v1600870423/renardRB_giegqb.png" alt="Renard Néon"/>
    </div>
  )
}
